import { Checkbox } from '@/components/ui/Checkbox';
import { useNotes } from '../../hooks/useNotes';
import type {
  FileNotesResponse,
  FileResultResponse,
} from '../../types/api.types';
import { IoCreate } from 'react-icons/io5';
import { Row } from '@/components/ui/layout/Row';
import { Column } from '@/components/ui/layout/Column';
import { Button } from '@/components/ui/Button';
import { Text } from '@/components/ui/base/Text';
interface NotesModalProps {
  onClose: () => void;
  notesData?: FileNotesResponse;
  resultData?: FileResultResponse;
}

const NotesModal = ({ onClose, notesData, resultData }: NotesModalProps) => {
  const {
    comment,
    fraud,
    isLoading,
    handleCommentChange,
    handleFraudChange,
    saveNotes,
  } = useNotes(notesData);

  const handleSave = async () => {
    await saveNotes(resultData?.id ?? '');
    onClose();
  };

  return (
    <div
      className="max:w-[700px] m-auto w-[min(500px,80vw)] rounded-lg bg-neutralBG px-5 py-4 dark:bg-neutralBG-dark"
      id="notes-modal"
    >
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-lg font-semibold">Notes</h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
          ✕
        </button>
      </div>
      <div className="text-md mb-2 font-normal">
        <Column>
          <Row>
            <IoCreate className="relative z-10 text-2xl focus:outline-none" />
            <Text>Commentaire:</Text>
          </Row>
          <textarea
            className="w-full rounded-md bg-[#f0f2f7] px-3 py-2 text-xs text-[#393939] dark:bg-opacity-5 dark:text-[white]"
            autoComplete="off"
            autoCorrect="off"
            rows={5}
            maxLength={500}
            value={comment}
            onChange={handleCommentChange}
            disabled={isLoading}
          />
          <Row className="flex pb-3">
            <span className="pr-4 font-medium">Fraude:</span>
            <Checkbox
              checked={fraud}
              onChange={(newValue) => handleFraudChange(newValue)}
            />
          </Row>
        </Column>
        <div className="flex items-center justify-end gap-2">
          <button
            onClick={onClose}
            className="text-md inline-flex h-9 items-center rounded-md px-3 text-sm shadow-md hover:bg-[#eaeaed] dark:hover:bg-[#545454]"
          >
            Annuler
          </button>
          <Button
            width="fit"
            disabled={isLoading}
            onClick={handleSave}
            className="text-md inline-flex h-9 items-center rounded-md bg-neutralBG px-3 text-sm shadow-md hover:bg-[#eaeaed] dark:bg-[#333135] dark:hover:bg-[#545454]"
          >
            Sauvegarder
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotesModal;
